import HubspotWithBulletsSideBySideFormComponent from "./hubspot-with-bullets-side-by-side-form-component";
import HubspotWithBulletsSideBySideFormConfig from "./hubspot-with-bullets-side-by-side-form-config";
import HubspotWithBulletsSideBySideFormAdvancedConfig from "./hubspot-with-bullets-side-by-side-form-advanced-config";

export default {
  HubspotWithBulletsSideBySideFormComponent,
  HubspotWithBulletsSideBySideFormConfig,
  HubspotWithBulletsSideBySideFormAdvancedConfig
};
